import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=6570e611&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=ts&"
export * from "./employees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570e611",
  null
  
)

export default component.exports